import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useRef } from "react";
import PropTypes from "prop-types";
import { extendedSystemStylesProps } from "@mixins";
import { Flex, Link } from "@base-ui";
import { Options, Option, Label, SelectButton } from "./selectLink.styles";
import { useOpen, useClickOutside } from "hooks";
import handleKeyDown from "./handleKeyDown";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["color", "space", "layout", "flexbox"];
var SelectLink = function SelectLink(props) {
  var _options$_selected, _options$_selected2;
  var id = props.id,
    label = props.label,
    _selected = props._selected,
    options = props.options,
    inverted = props.inverted,
    hideLabel = props.hideLabel,
    className = props.className,
    selectedPrefix = props.selectedPrefix;
  var _useState = useState(_selected),
    _useState2 = _slicedToArray(_useState, 2),
    activeFocus = _useState2[0],
    setActiveFocus = _useState2[1]; //idx
  var _useOpen = useOpen(false),
    open = _useOpen.open,
    setOpen = _useOpen.setOpen,
    toggleOpen = _useOpen.toggleOpen;
  var containerRef = useRef();
  var selectRef = useRef();
  handleKeyDown(id, containerRef, selectRef, open, setOpen, activeFocus, setActiveFocus, options);
  useClickOutside(containerRef, function () {
    setOpen(false);
    setActiveFocus(-1);
  }, open);
  var optionsMarkup = options.map(function (option, idx) {
    return /*#__PURE__*/_jsx(Option, {
      id: "".concat(id, "-option-").concat(idx),
      role: "option",
      title: option.label,
      children: /*#__PURE__*/_jsx(Link, {
        id: "".concat(id, "-link-").concat(idx),
        label: option.label,
        tabIndex: -1,
        onClick: function onClick() {
          return setOpen(false);
        },
        to: option.to,
        children: option.label
      })
    }, option.id);
  });
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(Label, {
      id: "".concat(id, "-label"),
      hideLabel: hideLabel,
      inverted: inverted,
      children: label
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      ref: containerRef,
      style: {
        position: "relative"
      },
      children: [/*#__PURE__*/_jsxs(SelectButton, {
        id: id,
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-controls": "".concat(id, "-listbox"),
        "aria-labelledby": "".concat(id, "-label ").concat(id),
        open: open,
        inverted: inverted,
        ref: selectRef,
        title: (_options$_selected = options[_selected]) === null || _options$_selected === void 0 ? void 0 : _options$_selected.label,
        onClick: toggleOpen,
        children: [selectedPrefix, " ", (_options$_selected2 = options[_selected]) === null || _options$_selected2 === void 0 ? void 0 : _options$_selected2.label]
      }), /*#__PURE__*/_jsx(Options, {
        id: "".concat(id, "-listbox"),
        "aria-labelledby": "".concat(id, "-label"),
        role: "listbox",
        open: open,
        children: optionsMarkup
      })]
    })]
  }));
};
SelectLink.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  _selected: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  hideLabel: PropTypes.bool,
  inverted: PropTypes.bool,
  className: PropTypes.string,
  selectedPrefix: PropTypes.any
};
export default SelectLink;